module.exports = __webpack_public_path__ + "static/img/2.6498ecf0.png";